import { render, staticRenderFns } from "./FormPriceInput.vue?vue&type=template&id=bc7140f6&scoped=true&"
import script from "./FormPriceInput.vue?vue&type=script&lang=js&"
export * from "./FormPriceInput.vue?vue&type=script&lang=js&"
import style0 from "./FormPriceInput.vue?vue&type=style&index=0&id=bc7140f6&prod&scoped=true&lang=css&"
import style1 from "./FormPriceInput.vue?vue&type=style&index=1&id=bc7140f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7140f6",
  null
  
)

export default component.exports